import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { FieldType, FormlyModule } from '@ngx-formly/core';

/**
 * @prop {boolean} stretchTabs - set whether tabs should stretch to fill the available space.
 * @prop {number} selectedIndex - set the index of the selected tab.
 */

@Component({
	selector: 'formly-tabs',
	template: `
		<mat-tab-group
			class="linq-tab-bar"
			[mat-stretch-tabs]="props?.stretchTabs"
			[selectedIndex]="props?.selectedIndex"
			(selectedIndexChange)="onSelectedIndexChange($event)"
		>
			<mat-tab *ngFor="let tab of field.fieldGroup; let i = index; let last = last" [label]="tab.props.label">
				<formly-field [field]="tab"></formly-field>
			</mat-tab>
		</mat-tab-group>
	`,
	standalone: true,
	imports: [MatTabsModule, NgFor, NgIf, FormlyModule],
})
export class FormlyTabsComponent extends FieldType {
	onSelectedIndexChange(index: number): void {
		if (this.props.change) {
			this.props.change(this.field, index);
		}
	}
}
